<mat-accordion class="management-accordion">
    <mat-expansion-panel [expanded]="displayMode === DisplayMode.List" [disabled]="true" hideToggle class="panel-list" [ngClass]="{ expanded: displayMode === DisplayMode.Form }">
        <mat-expansion-panel-header
            collapsedHeight="48px"
            expandedHeight="48px"
            [ngClass]="{ 'events-inactive': !context?.formContext.formVisible, 'events-active': context?.formContext.formVisible }"
            class="detail-header">
            <app-list-header
                [createRight]="displayAddbuttom"
                titleText="Adresses mail"
                createIconText="Ajouter une adresse mail"
                importDatasourceName="emailAddresses"
                (created)="onEmailAddressCreated()"
                (exported)="onEmailAddressesExported()"
                (imported)="onEmailAddressesImported()"
                (helped)="onEmailAddressesHelped()"></app-list-header>
        </mat-expansion-panel-header>
        <app-email-addresses-list
            #itemsList
            (itemSelected)="onEmailAddressSelected($event)"
            (itemDisplayed)="onEmailAddressDisplayed($event)"
            (itemEdited)="onEmailAddressEdited($event)"
            (itemDeleted)="onEmailAddressDeleted($event)"
            (itemDuplicated)="onEmailAddressDuplicated($event)"></app-email-addresses-list>
    </mat-expansion-panel>
    @if (displayMode === DisplayMode.Form) {
        <mat-expansion-panel [disabled]="!context?.formContext.formVisible" [expanded]="displayMode === DisplayMode.Form" [disabled]="true" hideToggle class="panel-form">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px" class="detail-header">
                <app-detail-header
                    [editRight]="displayEditbuttom"
                    [formMode]="context?.formMode"
                    [displayName]="context?.formContext.item.getDisplayName()"
                    [id]="context?.formContext.item.id"
                    (displayed)="onEmailAddressDisplayed(context?.formContext.item)"
                    (edited)="onEmailAddressEdited(context?.formContext.item)"
                    (helped)="onEmailAddressesHelped()"
                    (backToList)="onBackToList()"></app-detail-header>
            </mat-expansion-panel-header>
            <app-email-address-detail [context]="context" (emailAddressUpdated)="emailAddressUpdated($event)" (canceled)="onBackToList()"></app-email-address-detail>
        </mat-expansion-panel>
    }
</mat-accordion>
